import { auth } from "../firebase/config";

export const EMAIL_VERIFICATION_REQUIRED_MESSAGE =
  "Please verify your email before posting, messaging, bidding, buying, reserving, or reviewing.";

export const canPerformTrustedAction = (authUser = auth.currentUser, userProfile = null) => {
  const activeUser = authUser || auth.currentUser;

  return Boolean(
    activeUser?.emailVerified ||
      userProfile?.verificationBypass === true ||
      userProfile?.isDemoAccount === true ||
      userProfile?.isAdmin === true ||
      userProfile?.admin === true
  );
};

export const shouldShowVerificationWarning = (
  authUser = auth.currentUser,
  userProfile = null
) => {
  const activeUser = authUser || auth.currentUser;

  return Boolean(activeUser && !canPerformTrustedAction(activeUser, userProfile));
};

export const isEmailVerified = (user = auth.currentUser, userProfile = null) =>
  canPerformTrustedAction(user, userProfile);

export const requireVerifiedEmail = (
  user = auth.currentUser,
  userProfile = null
) => {
  if (canPerformTrustedAction(user, userProfile)) return true;

  alert(EMAIL_VERIFICATION_REQUIRED_MESSAGE);
  return false;
};
